var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcSidebarClose = function SvgIcSidebarClose(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 12,
    viewBox: "0 0 21 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    "data-name": "Group 302",
    transform: "translate(-26.193 -34.538)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_menu_24px",
    d: "M3,18H13V16H3Zm0-5H13V11H3ZM3,6V8H13V6Z",
    transform: "translate(23.193 28.538)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_chevron_left_24px",
    d: "M8,7.41,9.41,6l6,6-6,6L8,16.59,12.58,12Z",
    transform: "translate(31.783 28.538)",
    fill: "#ccc"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcSidebarClose);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_sidebar_close.8d9f700397e270061366c49cda119893.svg";